<template>
  <div>
    <filtro-reporte-general-lineas/>
  </div>
</template>

<script>
// Vuex

import FiltroReporteGeneralLineas from "../../components/filtros/lineas/FiltroReporteGeneralLineas";

export default {
  data(){

    return {
    }
    

  },
  components: { FiltroReporteGeneralLineas },


};
</script>
<style></style>
